import { styled } from '@mui/material/styles';
import { Box, Typography, GlobalStyles } from '@mui/material';

// Global styles that need to be applied to the entire app
export const GlobalStyleOverrides = () => (
  <GlobalStyles
    styles={{
      html: {
        '--section-background-color':
          'linear-gradient(135deg, rgba(5, 9, 18, 0.95), rgba(6, 19, 34, 0.9))',
        '--image-gradient':
          'linear-gradient(145deg, rgba(12, 74, 110, 0.6), rgba(34, 197, 94, 0.6))',
        '--imp-text-color': '#22d3ee',
      },
      body: {
        margin: 0,
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        backgroundColor: '#020617',
        backgroundImage:
          'radial-gradient(circle at 20% 20%, rgba(34,211,238,0.08), transparent 25%), radial-gradient(circle at 80% 0%, rgba(74,222,128,0.1), transparent 22%), repeating-linear-gradient(0deg, rgba(12,18,32,0.65), rgba(12,18,32,0.65) 1px, transparent 1px, transparent 32px), repeating-linear-gradient(90deg, rgba(12,18,32,0.65), rgba(12,18,32,0.65) 1px, transparent 1px, transparent 32px)',
        backgroundSize: '100% 100%, 100% 100%, 32px 32px, 32px 32px',
        scrollbarWidth: 'thin',
        scrollbarColor: 'rgba(34, 211, 238, 0.8) #0b1224',
        '&::-webkit-scrollbar': {
          width: '7px',
        },
        '&::-webkit-scrollbar-track': {
          background: '#0b1224',
        },
        '&::-webkit-scrollbar-thumb': {
          background: 'rgba(34, 211, 238, 0.8)',
          borderRadius: '12px',
          '&:hover': {
            background: 'rgba(74, 222, 128, 0.95)',
          },
        },
      },
      '#no-scroll': {
        overflow: 'hidden',
        height: '100vh',
      },
      '#tsparticles': {
        position: 'fixed !important',
        backgroundRepeat: 'no-repeat !important',
        backgroundSize: 'cover !important',
        width: '100%',
        height: '100%',
      },
      '@keyframes wave-animation': {
        '0%': { transform: 'rotate(0deg)' },
        '10%': { transform: 'rotate(14deg)' },
        '20%': { transform: 'rotate(-8deg)' },
        '30%': { transform: 'rotate(14deg)' },
        '40%': { transform: 'rotate(-4deg)' },
        '50%': { transform: 'rotate(10deg)' },
        '60%': { transform: 'rotate(0deg)' },
        '100%': { transform: 'rotate(0deg)' },
      },
      '@keyframes slideDown': {
        from: {
          opacity: 0,
          transform: 'translateY(-10px)',
        },
        to: {
          opacity: 1,
          transform: 'translateY(0)',
        },
      },
      '@keyframes gameFloat': {
        '0%, 100%': {
          transform: 'translateY(0) rotate(0deg)',
        },
        '50%': {
          transform: 'translateY(-10px) rotate(5deg)',
        },
      },
      '@keyframes ghostFloat': {
        '0%, 100%': {
          transform: 'translateY(0) scale(1)',
          opacity: 0.8,
        },
        '50%': {
          transform: 'translateY(-15px) scale(1.1)',
          opacity: 1,
        },
      },
      '@keyframes rocketLaunch': {
        '0%': {
          transform: 'translateY(0) rotate(0deg)',
        },
        '25%': {
          transform: 'translateY(-5px) rotate(-5deg)',
        },
        '50%': {
          transform: 'translateY(-15px) rotate(0deg)',
        },
        '75%': {
          transform: 'translateY(-25px) rotate(5deg)',
        },
        '100%': {
          transform: 'translateY(-35px) rotate(0deg)',
          opacity: 0,
        },
      },
      '@keyframes likeAnimation': {
        '0%': {
          transform: 'scale(1.5)',
        },
        '100%': {
          transform: 'scale(1)',
        },
      },
    }}
  />
);

// Purple text component (replaces .purple class)
export const PurpleText = styled('span')({
  color: 'var(--imp-text-color) !important',
});

// Section containers
export const SectionContainer = styled(Box)({
  paddingTop: '150px',
  paddingBottom: '30px',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background:
      'linear-gradient(135deg, rgba(5, 9, 18, 0.95), rgba(6, 19, 34, 0.9))',
    zIndex: -1,
  },
});

// Section titles
export const SectionTitle = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  marginBottom: theme.spacing(2),
  fontSize: '2.5rem',
  fontWeight: 'bold',
  [theme.breakpoints.down('md')]: {
    fontSize: '2rem',
  },
  '& .purple': {
    color: '#22d3ee',
    fontWeight: 'bold',
  },
}));

export const SectionSubtitle = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  marginBottom: theme.spacing(6),
  fontSize: '1.1rem',
  color: theme.palette.text.secondary,
}));
